import React from "react"
import { Theme } from "@life-without-barriers/react-components/src/Interfaces"
import { ThemeProvider } from "styled-components"
import ErrorCSS from "./ErrorCSS"
import { GlobalCSS } from "@life-without-barriers/react-components"

interface Props {
  children: React.ReactNode
  theme: Theme
}

// This layout is for error pages so we excluded footer
const Layout = ({ children, theme }: Props) => {
  return (
    <ThemeProvider theme={theme}>
      <div className="vh-100-l">
        <GlobalCSS />
        <ErrorCSS />
        <main id="main" role="main">
          {children}
        </main>
      </div>
    </ThemeProvider>
  )
}

export default Layout
